/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const PurchaseOrder = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/PurchaseOrder",
      top: "1",
      filter: `Code eq ${code} &$expand=Supplier($select=DefaultBranchCode,WetApplicable,TermCalculation,Terms,Name,Code,IsTaxableSupplier)`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async savePurchaseOrder(payload, orderId) {
    // eslint-disable-next-line no-debugger
    // debugger;
    const url = `api/Save_PurchaseOrder`;

    if (orderId) {
      return await ApiService.put(url, orderId, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },

  async getCustomData(params) {
    const requestScreenData = {
      url: "api/" + params.url,
      filter: params.filter,
      select: params.select,
    };

    if (params.filter) requestScreenData.filter = params.filter;

    if (params.select) requestScreenData.select = params.select;

    if (params.sort) requestScreenData.orderby = params.sort;

    return await ApiService.oDataGet(requestScreenData);
  },

  async cancelOrder(payload) {
    const url = `api/Save_PurchaseOrderCancel`;
    return await ApiService.post(url, payload);
  },

  async completeOrder(payload) {
    const url = `api/Save_PurchaseOrderComplete`;
    return await ApiService.post(url, payload);
  },
};

export { PurchaseOrder };
